import {Link} from "react-router-dom";
import ArrowRightShowAll from "../../icons/ArrowRightShowAll";
import styled from "styled-components";

export default function ShowAllCarouselButton({
  to = '',
  text = ''
}) {
  return (
    <Container to={to}>
      <IconContainer>
        <ArrowRightShowAll />
      </IconContainer>
      <span>{text}</span>
    </Container>
  )
}

const Container = styled(Link)`
  height: 100%;
  width: 11.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: .5rem;

  span {
    display: block;
    font-size: 1.3125rem;
    max-width: 6.375rem;
    font-weight: 400;
    text-align: center;
  }
`;

const IconContainer = styled.div`
  background-color: #F3EFEC;
  border-radius: 50%;
  height: 6.375rem;
  width: 6.375rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  svg {
    height: 1.8125rem;
  }
`;
